import React from "react";
import { Box, Button, ButtonGroup } from "@mui/material";
import BusinessFunctions from "./Business_Functions";
import DiscoveredAssets from "./Discovered_Assets";

export default function OrganizationAssetsIndex() {
  const [view, setView] = React.useState("business");

  return (
    <Box>
      {/* <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <ButtonGroup variant="outlined">
          <Button
            variant={view === "business" ? "contained" : "outlined"}
            sx={(theme) =>
              view === "business"
                ? {
                    backgroundColor: theme.palette.button.main,
                    color: theme.palette.button.contrastText,
                    "&:hover": { backgroundColor: theme.palette.button.dark },
                  }
                : {
                    borderColor: theme.palette.button.main,
                    color: theme.palette.button.main,
                    "&:hover": {
                      borderColor: theme.palette.button.dark,
                      color: theme.palette.button.dark,
                    },
                  }
            }
            onClick={() => setView("business")}
          >
            BusinessFunctions
          </Button>
          <Button
            variant={view === "discovered" ? "contained" : "outlined"}
            sx={(theme) =>
              view === "discovered"
                ? {
                    backgroundColor: theme.palette.button.main,
                    color: theme.palette.button.contrastText,
                    "&:hover": { backgroundColor: theme.palette.button.dark },
                  }
                : {
                    borderColor: theme.palette.button.main,
                    color: theme.palette.button.main,
                    "&:hover": {
                      borderColor: theme.palette.button.dark,
                      color: theme.palette.button.dark,
                    },
                  }
            }
            onClick={() => setView("discovered")}
          >
            Discovered Assets
          </Button>
        </ButtonGroup>
      </Box> */}

      <Box>
        <BusinessFunctions />
      </Box>
    </Box>
  );
}
